import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { RootState } from '@root/app.state';
import { selectUser } from '@platform/platform.selectors';
import { CurrentUser } from '@platform/platform.state';

@Injectable()
export class AcceptLanguageHttpInterceptor implements HttpInterceptor {
  constructor(private store$: Store<RootState>) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.getUser();
    const acceptLanguage = user?.language === 'English' ? 'en-US' : 'de-CH';

    req = req.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Accept-Language': acceptLanguage,
      },
    });

    return next.handle(req);
  }

  private getUser(): CurrentUser {
    let state: CurrentUser;

    this.store$
      .select(selectUser)
      .pipe(take(1))
      .subscribe((s) => (state = s.data));

    return state!;
  }
}
